import { PaymentProvider } from "@greenflagdate/shared";
import { AuthorizeNetCardFields } from "../../../components/PaymentForm/AuthorizeNetCardFields";
import { PaymentClientAdapter } from "../types";
import { loadAuthorizeAccept } from "./acceptJs";
import { translateAnetCode } from "./errorMap";

export const authorizeNetClientAdapter: PaymentClientAdapter = {
  provider: PaymentProvider.AuthorizeNet,
  preload: loadAuthorizeAccept,
  CardFields: AuthorizeNetCardFields,
  translateError: translateAnetCode,
};
